module.exports = require("npm:places.js@1.4.12/index.js");